import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const getShopifyShopBillingUsage = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `billing/usage`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}